import { AnyObject } from '@mri/types';
import { FormGroup } from '@angular/forms';
import { FormFieldConfig } from '../../../types/form-field-config';
import { FormFieldType } from '../../../types/form-field-type';
import { toBoolean, toNumber } from '@mri/functions';

export class FormBuild<T = AnyObject> {

  get formGroup(): FormGroup {
    return this._form;
  }

  get configs(): FormFieldConfig[] {
    return this._configs;
  }

  constructor(private _form: FormGroup, private _configs: FormFieldConfig[]) {
  }

  getObject(): T {
    const object: AnyObject = {};

    this._configs.forEach(({key}) => object[key || ''] = this.getValue(key || ''));
    return object;
  }

  getValue( key: string): string | number | boolean | null{
    const config = this._configs.find( c => c.key === key);
    const control =  this._form.controls[key];
    if(!config || !control) return null;

    if(config.type === FormFieldType.NUMBER) return toNumber(control.value);
    if(config.type === FormFieldType.BOOLEAN) return toBoolean(control.value);

     return control.value.toString();
  }
}
